// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-container {
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

/* Default styles for Swiper slide and image */
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  object-fit: cover;
  width: 100%;
}

/* Custom slide image size */
.custom-slide-image {
  max-width: 500px;
  max-height: 400px;
  width: 100%;
}

/* Custom Swiper slide size */
.custom-swiper-slide {
  max-width: 500px;
  max-height: 400px;
  width: 100%;
  height: auto;
}

.custom-swiper-slide:first-child {
  margin-left: auto;
}

.custom-swiper-slide:last-child {
  margin-right: auto !important;
}

.arrow-button {
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 10;
  /* Padding for better click/touch target */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.left-arrow {
  left: 10px;
  /* Adjust as needed */
}

.right-arrow {
  right: 10px;
  /* Adjust as needed */
}

/* Media queries for responsiveness */
@media (max-width: 1200px) {

  .custom-slide-image,
  .custom-swiper-slide {
    /* Adjust according to space between slides */
    width: calc(100% - 30px);
    height: auto;
    max-height: 400px;
  }
}

@media (max-width: 800px) {

  .custom-slide-image,
  .custom-swiper-slide {
    width: calc(100% - 30px);
    height: auto;
    max-height: 400px;
  }
}

@media (max-width: 600px) {

  .custom-slide-image,
  .custom-swiper-slide {
    width: calc(100% - 30px);
    height: auto;
    max-height: 400px;
  }
}

.price-container {
  display: flex;
  align-items: center; /* Align items vertically centered */
  gap: 8px; /* Add some space between the items */
}

.content-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  max-width: 81rem;
  margin: 0 auto;
}

.floating-box-container {
  position: relative;
  width: 38%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Listing/custom-slider.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;;EAEE;;IAGE,6CAA6C;IAU7C,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;EATnB;AACF;;AAYA;;EAEE;;IAEE,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;;EAEE;;IAEE,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,QAAQ,EAAE,qCAAqC;AACjD;;AAEA;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd","sourcesContent":[".carousel-container {\r\n  position: relative;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Default styles for Swiper slide and image */\r\n.swiper-slide {\r\n  text-align: center;\r\n  font-size: 18px;\r\n  background: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.swiper-slide img {\r\n  display: block;\r\n  object-fit: cover;\r\n  width: 100%;\r\n}\r\n\r\n/* Custom slide image size */\r\n.custom-slide-image {\r\n  max-width: 500px;\r\n  max-height: 400px;\r\n  width: 100%;\r\n}\r\n\r\n/* Custom Swiper slide size */\r\n.custom-swiper-slide {\r\n  max-width: 500px;\r\n  max-height: 400px;\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.custom-swiper-slide:first-child {\r\n  margin-left: auto;\r\n}\r\n\r\n.custom-swiper-slide:last-child {\r\n  margin-right: auto !important;\r\n}\r\n\r\n.arrow-button {\r\n  position: absolute !important;\r\n  top: 50% !important;\r\n  transform: translateY(-50%) !important;\r\n  z-index: 10;\r\n  /* Padding for better click/touch target */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.left-arrow {\r\n  left: 10px;\r\n  /* Adjust as needed */\r\n}\r\n\r\n.right-arrow {\r\n  right: 10px;\r\n  /* Adjust as needed */\r\n}\r\n\r\n/* Media queries for responsiveness */\r\n@media (max-width: 1200px) {\r\n\r\n  .custom-slide-image,\r\n  .custom-swiper-slide {\r\n    width: calc(100% - 30px);\r\n    /* Adjust according to space between slides */\r\n    height: auto;\r\n    max-height: 400px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n\r\n  .custom-slide-image,\r\n  .custom-swiper-slide {\r\n    width: calc(100% - 30px);\r\n    height: auto;\r\n    max-height: 400px;\r\n  }\r\n}\r\n\r\n@media (max-width: 800px) {\r\n\r\n  .custom-slide-image,\r\n  .custom-swiper-slide {\r\n    width: calc(100% - 30px);\r\n    height: auto;\r\n    max-height: 400px;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n\r\n  .custom-slide-image,\r\n  .custom-swiper-slide {\r\n    width: calc(100% - 30px);\r\n    height: auto;\r\n    max-height: 400px;\r\n  }\r\n}\r\n\r\n.price-container {\r\n  display: flex;\r\n  align-items: center; /* Align items vertically centered */\r\n  gap: 8px; /* Add some space between the items */\r\n}\r\n\r\n.content-wrapper {\r\n  display: flex;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  position: relative;\r\n  max-width: 81rem;\r\n  margin: 0 auto;\r\n}\r\n\r\n.floating-box-container {\r\n  position: relative;\r\n  width: 38%;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
